exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.tooltip__tooltip--32Y5X {\n    margin-top: 5px;\n    transform: translateX(-50%);\n    position: absolute;\n    top: 100%;\n    left: 50%;\n}\n", ""]);

// exports
exports.locals = {
	"tooltip": "tooltip__tooltip--32Y5X"
};